import { HttpErrorResponse } from '@angular/common/http'
import { createAction, props } from '@ngrx/store'
import { GiftAidEntity, GiftAidValueSubmit } from './gift-aid.models'

export const loadGiftAid = createAction('[GiftAid/API] Load GiftAid')

export const loadGiftAidSuccess = createAction(
  '[GiftAid/API] Load GiftAid Success',
  props<{ giftAid: GiftAidEntity[] }>(),
)

export const loadGiftAidFailure = createAction(
  '[GiftAid/API] Load GiftAid Failure',
  props<{ error: HttpErrorResponse }>(),
)

export const createGiftAidValue = createAction(
  '[GiftAid/API] Submit giftaid value',
  props<{ value: GiftAidValueSubmit[] }>(),
)

export const createGiftAidValueSuccess = createAction('[GiftAid/API] Create gift aid value success')

export const createGiftAidValueFailure = createAction(
  '[GiftAid/API] Create gift aid value failure',
  props<{ error: HttpErrorResponse }>(),
)

export const showGiftAidDialog = createAction('[GiftAid] Show Gift Aid Dialog')
